import { render, staticRenderFns } from "./StudySetEditFooter.vue?vue&type=template&id=978bfb00&scoped=true&"
import script from "./StudySetEditFooter.vue?vue&type=script&lang=js&"
export * from "./StudySetEditFooter.vue?vue&type=script&lang=js&"
import style0 from "./StudySetEditFooter.vue?vue&type=style&index=0&id=978bfb00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978bfb00",
  null
  
)

export default component.exports